import { AngleLeftIcon, Button } from "@dbn/omnichannel-design-system-g4p";
import { RuntimeLocaleKey, useFormatMessage } from "../../intl";

type Props = {
  action: () => unknown;
  disabled?: boolean;
  className?: string;
  buttonVariant?: "text" | "secondary";
  showLeftIcon?: boolean;
};

export function BackButton(props: Props) {
  const formatMessage = useFormatMessage();

  return (
    <Button
      variant={
        props.buttonVariant !== undefined ? props.buttonVariant : "secondary"
      }
      icon={
        props.showLeftIcon !== undefined && props.showLeftIcon
          ? AngleLeftIcon
          : undefined
      }
      size="default"
      label={formatMessage("generic.backToPrevStep" as RuntimeLocaleKey)}
      action={props.action}
      disabled={props.disabled}
      className={props.className}
    />
  );
}
